export enum DayOfWeek {
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  SATURDAY = 'SATURDAY',
  TUESDAY = 'TUESDAY',
  MONDAY = 'MONDAY',
  FRIDAY = 'FRIDAY',
  SUNDAY = 'SUNDAY',
}
